function swapMap(mapStructure) {
  const reversedPair = Array.from(mapStructure);
  return new Map(reversedPair.map(elem => elem.reverse()));
}

export default swapMap;
